import React from 'react'
import styles from './styles.css'
import {Link} from 'react-router'
import CoinCircle from 'App/components/CoinCircle'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import formatCurrency from 'App/helpers/formatCurrency'

@withGraphQL(gql`
  query getCoins {
    markets(secondaryCurrencyCode: "CLP") {
      code
      mainCurrency {
        code
        name
      }
      secondaryCurrency {
        code
        units
        format
        symbol
      }
      lastTrade {
        price
      }
    }
  }
`)
export default class Currencies extends React.Component {
  static propTypes = {
    markets: PropTypes.array
  }

  renderCoins() {
    return this.props.markets.filter(market => !!market.lastTrade).map(market => {
      return (
        <Link key={market.code} to={`/exchange/${market.code}`} className={styles.currency}>
          <div className={styles.icon}>
            <CoinCircle size={35} currencyCode={market.mainCurrency.code} />
          </div>
          <div className={styles.content}>
            <div className={styles.name}>{market.mainCurrency.name}</div>
            <div className={styles.price}>
              {formatCurrency(market.lastTrade.price, market.secondaryCurrency, {
                symbol: true,
                code: true
              })}
            </div>
          </div>
        </Link>
      )
    })
  }

  render() {
    return <div className={styles.container}>{this.renderCoins()}</div>
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Home/Layout/Nav/Currencies/index.js